import * as React from "react";
import { Button } from "@/components/ui";
import { Review } from "@/services/bedrock/dtos/Review";
import { useShareFlow } from "./ShareFlowProvider";
import { ReviewPicker } from "./ReviewPicker";

/** The carousel's reviews, with the way back to a single-review post. */
export const CarouselPanel: React.FC<{ onEditQuote?: (review: Review) => void }> = ({ onEditQuote }) => {
  const flow = useShareFlow();
  const { design } = flow;
  if (!design) return null;

  const reviews =
    flow.pinnedReview && !flow.postableReviews.some(r => Number(r.id) === flow.pinnedId)
      ? [flow.pinnedReview, ...flow.postableReviews]
      : flow.postableReviews;

  return (
    <div
      className="flex flex-col gap-3 rounded-xl border border-slate-200 bg-slate-50/60 p-4"
      data-testid="carousel-panel"
    >
      <ReviewPicker
        reviews={reviews}
        selectedIds={flow.reviewIds}
        pinnedId={flow.pinnedId ?? flow.reviewIds[0] ?? null}
        min={Math.max(2, design.minReviews)}
        max={design.maxReviews}
        loading={flow.postableLoading}
        onChange={flow.setReviewIds}
        onAddBest={flow.addBestReviews}
        quoteEdits={flow.quoteEdits}
        onEditQuote={onEditQuote}
      />
      <div>
        <Button variant="link" size="sm" className="px-0" onClick={flow.endCarousel}>
          Back to one review
        </Button>
      </div>
    </div>
  );
};
